import Box from '@mui/material/Box'
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import LockIcon from '@mui/icons-material/LockOutlined'
import PinIcon from '@mui/icons-material/PinOutlined';
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import InfoTile from '../shared/InfoTile'
import Loader from '../shared/Loader'

import {connect} from '../../state/hooks/tools'
import {isEmpty, fullName} from '../../lib/tools'
import {formatDate, findRecordByAttribute} from '../../lib/data'

import './personalInfo.scss'

const PersonalInfo = props => (
  <Loader loading={isEmpty(props.currentUser) || isEmpty(props.passwords)}>
    <Stack className='personal-info' component='div'>
      <Typography variant='h4' gutterBottom>Personal Info</Typography>
      <Typography className='text' variant='body2' gutterBottom>
        Here's some vital information about your account since you joined {formatDate(props.currentUser?.createdAt)}.
      </Typography>
      <Box className='tiles' component='div'>
        <InfoTile icon={AccountBoxOutlinedIcon} label='Name' details={[fullName(props.currentUser)]} />
        <InfoTile icon={EmailOutlinedIcon} label='Email' details={props.emails.map(email => email.address)} />
        <InfoTile icon={LockIcon} label='Password' details={[`Last updated at: ${formatDate(props.password.updatedAt)}`]} />
        <InfoTile icon={PinIcon} label='2FA' details={[`Enabled at: ${formatDate(props.tfaConfig.updatedAt)}`]} />
      </Box>
    </Stack>
  </Loader>
)

const mapStateToProps = ({users, emails, passwords, tfa}) => ({
  emails: [],
  tfaConfig: findRecordByAttribute({records: tfa.tfaConfigs, attribute: 'userId', id: users.currentUser?.id}),
  password: findRecordByAttribute({records: passwords.passwords, attribute: 'userId', id: users.currentUser?.id}),
  ...users,
  ...emails,
  ...passwords,
  ...tfa
})

export default connect(mapStateToProps)(PersonalInfo)
